module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flower-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "dots-container",
    style: (_vm.dotsContainerStyle)
  }, [_c('div', {
    staticClass: "big-dot",
    style: (_vm.biggerDotStyle)
  }, [_c('div', {
    staticClass: "small-dot",
    style: (_vm.smallerDotStyle)
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29c03a02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/FlowerSpinner.vue
// module id = 367
// module chunks = 1